import { render, staticRenderFns } from "./SumupDetailTotal.vue?vue&type=template&id=d6ff61e6&scoped=true&"
import script from "./SumupDetailTotal.vue?vue&type=script&lang=ts&"
export * from "./SumupDetailTotal.vue?vue&type=script&lang=ts&"
import style0 from "./SumupDetailTotal.vue?vue&type=style&index=0&id=d6ff61e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6ff61e6",
  null
  
)

export default component.exports